// ============================================================================
// ARCHIVO GENERADO AUTOMÁTICAMENTE — NO EDITAR A MANO
// Fuente: scripts/catalogo_productos.xlsx (hoja "Home")
// Generado por: scripts/generarCatalogo.js (se corre en cada build)
// Generado el: 2026-10-01T00:18:07.746Z
// ============================================================================

import LineaProductos from './ProductosLinea';
import '../styles/home-tienda.css';

const Tienda = () => {
  return (
    <div className='div-tienda-home'>

      <LineaProductos
          tagIds={[6]}
          nombre="Más Vendidos"
      />

      <LineaProductos
          tagIds={[9]}
          nombre="Papel Institucional"
      />

      <LineaProductos
          tagIds={[14, 15, 16]}
          nombre="Escobas, trapeadores y mops"
      />

      <LineaProductos
          categoriaId={4}
          nombre="Cafetería"
      />

      <LineaProductos
          categoriaId={5}
          nombre="Papelería"
      />

      <LineaProductos
          tagIds={[3]}
          nombre="Aromatizantes"
      />

    </div>
  );
}
export default Tienda;
